import { defineComponent } from 'vue'
import './index.scss'

export default defineComponent({
  name: 'ModuleHeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  },
  setup(props, { slots }) {
    return () => (
      <header class="module-header">
        <div class="module-header-main">
          <h2 class="module-header-title">{props.title}</h2>
          {slots.default?.()}
        </div>
        {props.description && <p class="module-header-desc">{props.description}</p>}
        <svg
          class="max-lg:portrait:hidden block rtl:-scale-x-100 w-full h-[5px]"
          viewBox="0 0 1440 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 4H1440" stroke="#FFBA00" stroke-miterlimit="10" />
          <path
            d="M1277.48 0H1440V4H1271L1274.24 1.20615C1275.14 0.429117 1276.29 0.000859238 1277.48 0Z"
            fill="#FFBA00"
          />
        </svg>
        <svg
          class="max-lg:portrait:block hidden w-full h-[3px] rtl:-scale-x-100"
          viewBox="0 0 335 3"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 1.99976H335" stroke="#FFBA00" stroke-miterlimit="10" />
          <path
            d="M265.139 0H335V2H262.353L263.747 0.603077C264.134 0.214559 264.628 0.000429619 265.139 0Z"
            fill="#FFBA00"
          />
        </svg>
      </header>
    )
  }
})
